// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"23fd0bcd","115":"601fb7be","880":"c309af9d"}[chunkId] + ".chunk.css";
};